/**
 * 【配送罚单页】
 */
import React from 'react';
import TableContent from './components/TableContent';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import { SearchBox, SearchItem } from '@/components/Layout';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import model from '@/reducers/aftersale/deliveryticket/model';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { XInput, XOKButton, XCancelButton, XDatePicker, XSelect, XInputNum } from '@/components/xqxc_ui';

class Main extends React.Component {
    state = {
        typeId: {},
        state: {},
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
        // 处罚原因
        this.props.getfindNames();
        // 状态
        this.props.getPunishmentStateEnum({ enumName: 'PunishmentStateEnum' });
        const { tel } = this.props.match.params || {};
        if (tel) {
            this.setState({ riderTel: tel });
        }
    }

    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
            // 查看详情
            case 'info':
                history.push({
                    pathname: `/home/aftersale/deliveryticket/detail/${record.id}`,
                });
                break;
            // 处理
            case 'deal':
                history.push({
                    pathname: `/home/aftersale/deliveryticket/appeal/${record.id}`,
                });
                break;
        }
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, riderTel, orderId, id, state, typeId } = this.state;
        const query = {
            riderTel,
            orderId,
            id,
            punishmentState: state.code,
            punishmentTypeId: typeId.id,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getfindList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ riderTel: undefined, orderId: undefined, id: undefined, state: {}, typeId: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    render() {
        const { findList, findNames, PunishmentStateEnum } = this.props;
        const { id, riderTel, orderId, typeId = {}, state = {} } = this.state;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={`${styles.flexBoxContainer} ${styles.orderContainer}`}>
                    <SearchBox>
                        <SearchItem>
                            <XInputNum
                                label='骑士手机号'
                                placeholder='请输入骑士手机号'
                                value={riderTel}
                                bindThis={this}
                                bindName='riderTel'
                                min={0}
                                precision={0}
                                maxLength={11}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInputNum
                                label='订单编号'
                                placeholder='请输入订单编号'
                                value={orderId}
                                bindThis={this}
                                bindName='orderId'
                                min={0}
                                precision={0}
                                maxLength={16}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInputNum
                                label='罚单编号'
                                placeholder='请输入罚单编号'
                                value={id}
                                bindThis={this}
                                bindName='id'
                                min={0}
                                precision={0}
                                maxLength={16}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='状态'
                                placeholder='请选择'
                                renderData={PunishmentStateEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={state.value}
                                showSearch={true}
                                bindThis={this}
                                bindName='state'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='处罚原因'
                                placeholder='请选择'
                                renderData={findNames}
                                dataIndex='name'
                                keyIndex='id'
                                value={typeId.name}
                                showSearch={true}
                                bindThis={this}
                                bindName='typeId'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent renderData={findList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive >
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
    getfindList: PropTypes.func,
    findList: PropTypes.object,
    getfindNames: PropTypes.func,
    findNames: PropTypes.array,
    getPunishmentStateEnum: PropTypes.func,
    PunishmentStateEnum: PropTypes.array
};

const mapStateToProps = (state) => ({
    findList: state.deliveryticket.findList,
    findNames: state.deliveryticket.findNames,
    PunishmentStateEnum: state.deliveryticket.PunishmentStateEnum,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);
